<template>
    <main class="main" :key="keyComponent">
        <div class="container">
            <div class="row">
                <div class="col-md-3">
                    <the-filters
                        @applyFilters="applyFilters"
                        :filters="filters"
                        :moduleName="'saleTrend'"
                        :clearable="!isLotteryUser"
                    />
                </div>
                <div class="col-md-9 mt-5 mt-md-0">
                    <div class="c-settings">
                        <sub-section-header title="Sprzedaż sumaryczna"/>

                        <div class="c-settings-filters">
                            <group-by
                                :text="'Grupuj po:'"
                                :moduleName="'saleTrend'"
                                :options="
                                    $store.getters.getSaleTrendGroupByOptions
                                "
                            ></group-by>
                        </div>
                    </div>

                    <div
                        v-if="
                            !chart ||
                                (chart && chart.series[0].data.length === 0)
                        "
                    >
                        Brak danych sprzedażowych spełniających kryteria
                    </div>
                    <lottery-info-container
                        clickable
                        v-else
                        customClass="px-1 pb-3"
                    >
                        <template #bottom>
                            <stat-chart :chartOptions="chart"
                                :key="keyChart"
                                :isCurrency="filters.type.value === 'AMOUNT'"
                                :colorsData="['rgb(107, 182, 69)']"
                            />
                        </template>
                    </lottery-info-container>

                    <div v-if="sum && filters.type.value === 'AMOUNT'" class="text-right mt-2 pr-2">
                        Suma sprzedaży: {{ sum | currency }}

                    </div>
                    <div v-else-if="sum && filters.type.value === 'QUANTITY'" class="text-right mt-2 pr-2">
                        Liczba paragonów: {{ sum }}
                    </div>

                    <div
                        class="c-table saleTrendTable mt-4 mb-4"
                        v-if="
                            saleTrend &&
                                saleTrend.dataForReport &&
                                saleTrend.dataForReport.length
                        "
                    >
                        <div class="c-thead">
                            <div class="c-td is-1">Lokalizacja</div>
                            <div
                                class="c-td is-2"
                                v-if="
                                    $store.getters.getSaleTrendGroupBy ===
                                        'TERMINAL'
                                "
                            >
                                Terminal
                            </div>
                            <div class="c-td is-3">
                                {{ filters.type.value === 'AMOUNT'
                                    ? 'Suma sprzedaży (PLN)' : 'Liczba paragonów' }}
                            </div>
                        </div>
                        <div class="c-tbody">
                            <div
                                class="c-row"
                                v-for="report in saleTrend.dataForReport"
                                :key="report.location_id"
                            >
                                <div class="c-tr">
                                    <div class="c-td is-1">
                                        <div class="typo-name">Lokalizacja</div>
                                        <span class="font-weight-bold">{{
                                            report.location_name
                                        }}</span>
                                        <br />
                                        <span>{{ report.street }}
                                            {{ report.building }},
                                            {{ report.postal_code }}
                                            {{ report.city }}</span>
                                    </div>
                                    <div
                                        class="c-td is-2"
                                        v-if="
                                            $store.getters
                                                .getSaleTrendGroupBy ===
                                                'TERMINAL'
                                        "
                                    >
                                        <div class="typo-name">Terminal</div>
                                        <span class="font-weight-bold">{{
                                            report.terminal_name
                                        }}</span>
                                    </div>
                                    <div v-if="filters.type.value === 'AMOUNT'" class="c-td is-3">
                                        <div class="typo-name">
                                            Suma sprzedaży (PLN)
                                        </div>
                                        <span class="font-weight-bold">{{
                                            report.sum_amount_per_period.toFixed(
                                                2
                                            )
                                        }}</span>
                                    </div>
                                    <div v-else class="c-td is-3">
                                        <div class="typo-name">
                                            Liczba paragonów
                                        </div>
                                        <span class="font-weight-bold">
                                            {{ report.sum_quantity_per_period }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>

<script>
import moment from 'moment'
import StatChart from '@/components/statistics/StatChart'
import LotteryInfoContainer from '@/components/lottery/LotteryInfoContainer.vue'

export default {
    data() {
        return {
            keyChart: 0,
            keyComponent: 0
        }
    },
    computed: {
        isLotteryUser() {
            return this.$store.getters.isLotteryUser
        },
        filters() {
            return this.$store.getters.getSaleTrendFilters
        },
        chart() {
            return this.$store.getters.getSaleTrendForChart
        },
        saleTrend() {
            return this.$store.getters.getSaleTrend
        },
        sum() {
            if (
                this.saleTrend &&
                this.saleTrend.dataForReport &&
                this.saleTrend.dataForReport.length
            ) {
                return this.saleTrend.dataForReport
                    .map(item => this.filters.type.value === 'AMOUNT'
                        ? item.sum_amount_per_period
                        : item.sum_quantity_per_period)
                    .reduce((a, b) => {
                        return a + b
                    })
            } else {
                return null
            }
        }
    },
    components: {
        StatChart,
        LotteryInfoContainer
    },
    methods: {
        resetFilters(filter, value) {
            if (filter === 'lastDays') {
                this.$store.dispatch('setFilter', {
                    filter: 'startDate',
                    value: moment()
                        .subtract(value, 'days')
                        .format('YYYY-MM-DD HH:mm:ss'),
                    moduleName: 'saleTrend'
                })
                this.$store.dispatch('setFilter', {
                    filter: 'endDate',
                    value: moment().format('YYYY-MM-DD HH:mm:ss'),
                    moduleName: 'saleTrend'
                })
                setTimeout(() => {
                    this.$store.dispatch('setFilter', {
                        filter: 'lastDays',
                        value: value,
                        moduleName: 'saleTrend'
                    })
                }, 0)
            }
        },
        applyFilters(payload) {
            if (
                payload.filter === 'startDate' ||
                payload.filter === 'endDate'
            ) {
                this.$store.dispatch('setFilter', {
                    filter: 'lastDays',
                    value: null,
                    moduleName: 'saleTrend'
                })
            }
            /* eslint-disable eqeqeq */
            this.resetFilters(payload.filter, payload.value)
            if (
                this.$router.currentRoute.query.page &&
                this.$router.currentRoute.query.page != 1
            ) {
                this.$router
                    .push({ query: { ...this.$route.query, page: 1 } })
                    .then(() => {
                        this.fetch()
                    })
            } else {
                this.fetch()
            }
        },
        fetch() {
            return this.$store.dispatch('saleTrendFetch')
        }
    },
    beforeCreate() {
        this.$store.dispatch('setSaleTrendFilters')
    },
    created() {
        this.$nextTick(() => {
            this.$store.dispatch('devicesFetch').then(() => {
                setTimeout(() => {
                    this.fetch()
                }, 0)
            })
        })
    },
    watch: {
        chart() {
            this.keyChart++
        }
    }
}
</script>
